import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/state/app.state';
import { FunctionsService } from '../../shared/services/functions.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  loading = false;
  processing = false;
  showError = false;
  changePasswordError = '';
  passwordMismatch = false;

  oldPasswordFieldType = 'password';
  newPasswordFieldType = 'password';
  confirmPasswordFieldType = 'password';

  passwordData = {
    email: '',
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  };
  constructor(
    private router: Router,
    private authService: AuthService,
    private store: Store<AppState>,
    private functions: FunctionsService
  ) { }

  ngOnInit(): void {
    const savedEmail = localStorage.getItem('pendingEmail');
    if (savedEmail) {
      this.passwordData.email = savedEmail;
    }
    // this.passwordData.emailAddress = user?.email;
  }
  togglePasswordVisibility(field: 'old' | 'new' | 'confirm') {
    if (field === 'old') {
      this.oldPasswordFieldType = this.oldPasswordFieldType === 'password' ? 'text' : 'password';
    } else if (field === 'new') {
      this.newPasswordFieldType = this.newPasswordFieldType === 'password' ? 'text' : 'password';
    } else {
      this.confirmPasswordFieldType = this.confirmPasswordFieldType === 'password' ? 'text' : 'password';
    }
  }

  onDismissError() {
    this.showError = false;
    this.changePasswordError = '';
  }


  changePassword() {
    this.passwordMismatch = this.passwordData.newPassword !== this.passwordData.confirmPassword;
    if (this.passwordMismatch) { return; }

    this.processing = true;

    const payload = {
      email: this.passwordData.email,
      oldPassword: this.passwordData.oldPassword,
      newPassword: this.passwordData.newPassword
    };
    // console.log('payload', payload);
    this.authService.loginUser('auth/change-password', payload).subscribe({
      next: (res) => {
        // console.log(res);
        this.processing = false;
        // ✅ Clear stored email after successful change
        localStorage.removeItem('pendingEmail');

        // ✅ You can also log the user in or redirect them to login
        this.router.navigate(['/login']);
      },
      error: (err) => {
        this.processing = false;
        this.showError = true;
        this.changePasswordError = err.error?.message || 'Something went wrong';
      }
    });
  }


}
